import { forwardRef, TextareaHTMLAttributes } from "react";
import styles from "./Form.module.css";
import { cx } from "../utils";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => (
    <textarea ref={ref} className={cx(styles.textarea, className)} {...props} />
));

Textarea.displayName = "Textarea";
